import React from 'react';
import styled from '@emotion/styled';
import { ReactComponent as Logo } from 'assets/icons/logoBarTrack.svg';
import { useTranslation } from 'react-i18next';

const message = [
  'Maintenance.scheduledMaintenance',
  'Maintenance.scheduledMaintenanceDescription',
  'Maintenance.scheduledMaintenanceDescription2',
  'Maintenance.scheduledMaintenanceDescription3',
  'Maintenance.cheers',
];

const MaintenancePage = () => {
  const { t } = useTranslation();
  const componentName = 'MaintenanceContainer';
  return (
    <StyledMaintenanceContainer className={componentName}>
      {message.map((message, index) => {
        return (
          <StyledMaintenanceMessage key={index} className={`${componentName}-message`}>
            {t(message)}
          </StyledMaintenanceMessage>
        );
      })}

      <StyledSvgContainer className={`${componentName}-message`}>
        <Logo />
      </StyledSvgContainer>
    </StyledMaintenanceContainer>
  );
};

export default MaintenancePage;

const StyledMaintenanceContainer = styled.div(() => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  height: '100vh',
  padding: '80px 25px 20px',
  margin: 'auto',
  maxWidth: '728px',

  '@media (min-width: 720px)': {
    padding: '120px 40px',
  },
}));

const StyledMaintenanceMessage = styled.p(() => ({
  fontSize: '12px',
  lineHeight: '2',
  margin: '8px 0',
  textAlign: 'justify',

  '@media (min-width: 720px)': {
    fontSize: '18px',
  },
}));

const StyledSvgContainer = styled.div(() => ({
  margin: '40px 0',
}));
